import { Log } from '../../AuxillaryService/Log';
import { IFrameWidgetConfigurationDetails } from './types';
import { isNotBlank } from '../../Utility/Blank';

type RunFromZipConfig = {
    encodedOriginUrl: string;
    indexFile: string;
    decodedOriginUrl: string;
};

export function extractRunFromZipConfig(
    config: IFrameWidgetConfigurationDetails
): RunFromZipConfig {
    let encodedOriginUrl: string;
    let indexFile: string;
    let decodedOriginUrl: string;

    if (config.run_from_zip) {
        if (isNotBlank(config.zip_url) && isNotBlank(config.zip_index_file)) {
            decodedOriginUrl = config.zip_url;
            encodedOriginUrl = encodeURIComponent(config.zip_url);
            indexFile = config.zip_index_file;
        } else {
            Log.Debug(
                `IFrame widget '${String(config.name)}' (widget id=${String(
                    config.id
                )}) is configured for Run From Zip, but zip_url or zip_index_file is not defined.`,
                null,
                __fileline
            );

            throw Error();
        }
    } else {
        let rest: string[];

        [, encodedOriginUrl, ...rest] = new URL(config.url).pathname.split('/');

        indexFile = rest.join('/');
        decodedOriginUrl = decodeURIComponent(encodedOriginUrl);
    }

    return {
        encodedOriginUrl,
        indexFile,
        decodedOriginUrl,
    };
}
